import pipe from 'lib/pipe';

import insertRecommendations from 'components/Recommended/insert';
import insertAdsIfNotNativeAd from './insertAdsIfNotNativeAd';
import insertInlineNewsletterModule from './insertInlineNewsletterModule';
import addEcommerce from './addEcommerce';
import splitIntoSections from './splitIntoSections';
import formatSections from './formatSections';
import sanitize from './sanitize';

export default function ({
  articleBody: body,
  article,
  ecommerceEnabled,
  nativeAd,
  adsEnabled,
  disableReco,
  amp,
  path,
  vertical,
}) {
  const { datePublished: articlePublishDate } = article;

  const sectionPipeline = pipe(
    sanitize,
    // flat array of data at this point, straight from the api
    insertAdsIfNotNativeAd(nativeAd, adsEnabled, ecommerceEnabled, amp),
    insertRecommendations(article, disableReco),
    insertInlineNewsletterModule(article, vertical),
    addEcommerce(ecommerceEnabled),
    // below changes up the array shape, no longer a flat array. this is the actual "getSections"
    splitIntoSections(amp),

    // formatSections below also turns each `items` subarray into React components

    // we need to pass article to formatSection because we need to know an article's publish date
    // when building affiliate links
    formatSections(amp, path, articlePublishDate, vertical),
  );

  return sectionPipeline(Array.from(body));
}
